import Cookies from 'js-cookie';
import { adminMainUrl } from '../../../Config.jsx';

// Operation Dashboard Count Actions
export const fetchOperationDashboardCountRequest = () => ({
    type: "FIND_OPERATION_DASHBOARD_COUNT_REQUEST",
});

export const fetchOperationDashboardCountSuccess = (data) => ({
    type: "FIND_OPERATION_DASHBOARD_COUNT_SUCCESS",
    payload: data,
});

export const fetchOperationDashboardCountFailure = (error) => ({
    type: "FIND_OPERATION_DASHBOARD_COUNT_FAILURE",
    payload: error,
});

export const getOperationDashboardCount = (tokenParam, userIdParam) => {
    return async function (dispatch) {
        dispatch(fetchOperationDashboardCountRequest());
        const token = tokenParam || Cookies.get('token');
        const user_id = userIdParam || Cookies.get('flexichain_user_id');

        let config = {
            method: "GET",
            headers: {
                'auth-token': token || '',
                'Authorization': token ? (token.startsWith('Bearer ') ? token : `Bearer ${token}`) : '',
                'user_id': user_id || '',
                'user-id': user_id || '',
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/operation-dashboard-count`;

        try {
            const res = await fetch(apiUrl, config);
            const resData = await res.json();
            if (res.ok && resData?.code === 200) {
                dispatch(fetchOperationDashboardCountSuccess(resData?.data || resData));
            } else if (res.ok && resData?.data) {
                dispatch(fetchOperationDashboardCountSuccess(resData.data));
            } else if (resData?.data) {
                dispatch(fetchOperationDashboardCountSuccess(resData.data));
            } else {
                dispatch(fetchOperationDashboardCountFailure(resData?.message || "Failed to fetch operation dashboard count"));
            }
        } catch (err) {
            console.log("ERROR in getOperationDashboardCount function(redux):", err);
            dispatch(fetchOperationDashboardCountFailure(err.message || "Network error"));
        }
    };
};
